export default "__VITE_ASSET__DNrjkE6W__"